import { createSelector } from '@reduxjs/toolkit'

const getBusinessApi = (state: any) => state.businessApi

export const businessApiSelector = createSelector(getBusinessApi, (businessApi) => businessApi)
